import React from "react";
import styles from "./RsvpIntro.module.css";
import { Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp1.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const RsvpIntro = () => {
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );

  console.log("rsvpData", rsvpData);

  const navigate = useNavigate();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        onBackClick={() => navigate(-1)}
      />
      <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <TextComponent textClass={styles.title} text={`${rsvpData.groom_name} and ${rsvpData.bride_name}`} />
            <TextComponent
              textClass={styles.text}
              text="We are excited to share our"
            >
              <h1 className={styles.specialText}>
                Special day{" "}
                <TextComponent textClass={styles.text1} text="with you!" />
              </h1>
            </TextComponent>
            <SubmitBotton
              btnClass={styles.btn}
              title="RSVP"
              onClick={() => navigate("/rsvp/rsvpDateTime")}
            />
          </div>
        </div>
        <div className={styles.imgContainer}>
          <img
            className={styles.innerImg}
            src={rsvpData?.event?.image ? rsvpData?.event?.image : Rsvp}
          />
        </div>
      </div>
    </div>
  );
};

export default RsvpIntro;
